import styled from 'styled-components';
import { variant, borders, BordersProps, textAlign, TextAlignProps } from 'styled-system';
import { basicTheme } from 'src/theme';
import { Box, BoxProps } from './Box';
import { Flex, FlexProps } from './Flex';

export type CommonCardProps = BordersProps &
  TextAlignProps & {
    variant?: keyof typeof basicTheme.cards;
  };

const cardStyle = variant({
  key: 'cards'
});

const cardStyles: NonEmptyArray<any> = [cardStyle, borders, textAlign];

export type CardProps = BoxProps & CommonCardProps;
export const Card = styled(Box)<CardProps>`
  ${cardStyles};
`;

export type FlexCardProps = FlexProps & CommonCardProps;
export const FlexCard = styled(Flex)<FlexCardProps>`
  ${cardStyles};
`;
